/* Stix smart search — mobile nav test (test_id: smart_search)
 *
 * Bucketing happens synchronously in snippets/smart-search-head.liquid and is
 * exposed as window.STIX_SS = { arm, live, forced, eligible }.
 * This file:
 *   1. fires the CRO exposure (both arms) when the test is live, via
 *      window.stixCroExpose (assets/stix-cro-expose.js)
 *   2. for arm "a" only: wires the mobile-nav Search button to a full-screen
 *      search screen with curated answers + live product cards.
 *
 * Data:   /search?view=smart-search-data   (metafield smart_search.data, or the
 *         snippet fallback). Never contains prices.
 * Cards:  /search?view=smart-search-cards&q=h1,h2  (live price, compare-at,
 *         automatic_discount metafield, B2B, currency, stock, variants).
 * Events: smart_search_open, search, smart_search_answer, smart_search_click.
 */
(function () {
  'use strict';
  var SS = window.STIX_SS;
  var CFG = window.STIX_SS_CFG || {};
  if (!SS) return;

  // ── 1. Exposure ────────────────────────────────────────────────────────────
  var trackForced = false;
  try { trackForced = new URLSearchParams(location.search).get('cl_ss_track') === '1'; } catch (e) {}
  function expose() {
    if (!SS.eligible) return;
    if (!(SS.live && !SS.forced) && !(SS.forced && trackForced)) return;
    var opts = { page_type: CFG.pageType || 'site', assignment_source: SS.forced ? 'url_override' : 'random' };
    if (typeof window.stixCroExpose === 'function') { window.stixCroExpose(SS.testId, SS.arm, opts); return; }
    try {
      (window.dataLayer = window.dataLayer || []).push({ event: 'ab_test_exposure', cl_test_id: SS.testId, cl_test_variant: SS.arm, page_type: opts.page_type, page_path: location.pathname });
    } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', expose); else expose();

  if (SS.arm !== 'a') return;

  // ── 2. Helpers ─────────────────────────────────────────────────────────────
  var DATA = null, dataPromise = null, cardCache = {};
  var DATA_URL = CFG.dataUrl || '/search?view=smart-search-data';
  var CARDS_URL = CFG.cardsUrl || '/search?view=smart-search-cards&type=product&q=';
  var SEARCH_URL = CFG.searchUrl || '/search';
  var FIT_URL = CFG.fitUrl || '/pages/quiz-find-your-fit-variants-perform-series-12';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    return ' ' + String(s || '').toLowerCase().replace(/[’'`]/g, '').replace(/°/g, ' ').replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ';
  }
  function url(u) { return u === 'fit' ? FIT_URL : u; }

  // GA4 gets `name`; dataLayer gets `dlName` (defaults to name). The GA4 `search`
  // event is pushed to dataLayer as smart_search_query so a GTM trigger on
  // dataLayer events can't double-count it.
  function track(name, params, dlName) {
    params = params || {};
    params.cl_test_id = SS.testId; params.cl_test_variant = SS.arm;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: dlName || name }, params)); } catch (e) {}
    var tries = 0;
    (function send() {
      if (typeof window.gtag === 'function') { try { window.gtag('event', name, params); } catch (e) {} return; }
      if (++tries < 6) setTimeout(send, 1000);
    })();
  }

  function loadData() {
    if (DATA) return Promise.resolve(DATA);
    if (dataPromise) return dataPromise;
    dataPromise = fetch(DATA_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) { DATA = JSON.parse(t); DATA.intents = (DATA.intents || []).filter(function (i) { return i.enabled !== false; }); return DATA; })
      .catch(function (e) { dataPromise = null; throw e; });
    return dataPromise;
  }

  function loadCards(handles) {
    var need = handles.filter(function (h) { return !(h in cardCache); });
    if (!need.length) return Promise.resolve(cardCache);
    return fetch(CARDS_URL + encodeURIComponent(need.join(',')), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var j = JSON.parse(t);
        CFG.currencyPrefix = j.currency_prefix || '';
        need.forEach(function (h) { cardCache[h] = null; });
        (j.products || []).forEach(function (p) { cardCache[p.handle] = p; });
        return cardCache;
      })
      .catch(function () { return cardCache; });
  }

  function findIntent(q) {
    var n = norm(q);
    if (!n.trim() || !DATA) return null;
    for (var i = 0; i < DATA.intents.length; i++) {
      var it = DATA.intents[i];
      for (var j = 0; j < it.kw.length; j++) {
        if (n.indexOf(' ' + norm(it.kw[j]).trim() + ' ') !== -1) return it;
      }
    }
    return null;
  }

  // Pick the variant that matches every wanted option value (case-insensitive) and is in stock.
  function pickVariant(p, want) {
    if (!want || !want.length) return null;
    var w = want.map(function (x) { return String(x).toLowerCase(); });
    var vs = (p.variants || []).filter(function (v) {
      var o = (v.o || []).map(function (x) { return String(x).toLowerCase(); });
      return v.a && w.every(function (x) { return o.indexOf(x) !== -1; });
    });
    return vs.length ? vs[0] : false;
  }

  // "lefty driver", "left handed wedge": the hand is a modifier on another intent.
  function isLefty(q) { return /(^| )(left|lefty|lefties|lefthanded|southpaw|lh)( |$)/.test(norm(q)); }
  function intentByKey(k) { for (var i = 0; i < DATA.intents.length; i++) if (DATA.intents[i].key === k) return DATA.intents[i]; return null; }

  // Resolve an intent's product list against live data: in-stock only, variant-aware.
  // extraWant (e.g. ['Left']) narrows every product to variants with that option, and
  // drops products that don't have one in stock.
  function resolveProducts(intent, q, extraWant) {
    var entries = (intent.products || []).slice();
    if (intent.byNumber) {
      var m = norm(q).match(/ (\d) ?iron /) || norm(q).match(/ (\d)iron /);
      var nums = m ? intent.byNumber[m[1]] : null;
      if (nums) entries = nums.map(function (h) { return { h: h }; }).concat(entries);
    }
    var seen = {}, out = [];
    entries.forEach(function (e) {
      if (out.length >= (intent.max || 3) || seen[e.h]) return;
      var p = cardCache[e.h];
      if (!p || !p.available) return;
      var want = (e.want || []).concat(extraWant || []);
      var v = pickVariant(p, want);
      if (v === false) return; // wanted variant not in stock
      seen[e.h] = 1;
      var spec = e.spec || '';
      if (extraWant && extraWant.length && !/left/i.test(spec)) spec = 'Left-handed' + (spec ? ' \u00b7 ' + spec : '');
      out.push({ p: p, v: v, spec: spec, pitch: e.pitch || (DATA.pitch || {})[e.h] || '' });
    });
    return out;
  }

  function allHandles(intent) {
    var hs = (intent.products || []).map(function (e) { return e.h; });
    if (intent.byNumber) Object.keys(intent.byNumber).forEach(function (k) { hs = hs.concat(intent.byNumber[k]); });
    return hs.filter(function (h, i) { return hs.indexOf(h) === i; });
  }

  function fillTokens(text, shown) {
    var ok = true;
    var out = String(text || '').replace(/\{from\}/g, function () {
      if (!shown.length) { ok = false; return ''; }
      var best = shown.reduce(function (a, b) { return (b.v ? b.v.pc : b.p.price_cents) < (a.v ? a.v.pc : a.p.price_cents) ? b : a; });
      return (CFG.currencyPrefix || '') + (best.v ? best.v.p : best.p.price);
    }).replace(/\{price:([a-z0-9\-]+)\}/g, function (_, h) {
      var p = cardCache[h];
      if (!p) { ok = false; return ''; }
      return (CFG.currencyPrefix || '') + p.price;
    });
    return { text: out, ok: ok };
  }

  // ── 3. UI ──────────────────────────────────────────────────────────────────
  var root, input, bodyEl, pushed = false, current = { q: '', intent: null }, suggestTimer = null;

  var ICON_SEARCH = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="M20 20l-3.5-3.5"></path></svg>';
  var ICON_X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>';
  var ICON_ARROW = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';
  var ICON_CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E43D30" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L19 7"></path></svg>';
  var ICON_CLUB = '<svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#B4B3AC" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M15 3L8 17"></path><path d="M8 17c-1 2.2-3.4 2.6-4.6 1.6-.7-.6-.3-1.6.6-1.9L8 15.6"></path></svg>';

  function ensureCss() {
    if (!CFG.cssUrl || document.getElementById('ss-css')) return;
    var l = document.createElement('link'); l.id = 'ss-css'; l.rel = 'stylesheet'; l.href = CFG.cssUrl; document.head.appendChild(l);
  }

  function build() {
    if (root) return;
    ensureCss();
    root = document.createElement('div');
    root.className = 'ss-root';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Search Stix');
    root.hidden = true;
    root.innerHTML =
      '<div class="ss-top">' +
        '<form class="ss-form" role="search" action="' + esc(SEARCH_URL) + '">' +
          '<label for="ss-input" class="ss-sr">Search Stix</label>' +
          '<span class="ss-form__icon">' + ICON_SEARCH + '</span>' +
          '<input id="ss-input" class="ss-input" type="search" name="q" autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="search" placeholder="Try &ldquo;senior&rdquo;, &ldquo;lefty&rdquo; or &ldquo;5 iron&rdquo;">' +
          '<button type="button" class="ss-clear" aria-label="Clear search" hidden>' + ICON_X + '</button>' +
        '</form>' +
        '<button type="button" class="ss-close">Cancel</button>' +
      '</div>' +
      '<div class="ss-body" aria-live="polite"></div>';
    document.body.appendChild(root);
    input = root.querySelector('.ss-input');
    bodyEl = root.querySelector('.ss-body');
    var clearBtn = root.querySelector('.ss-clear');

    root.querySelector('.ss-form').addEventListener('submit', function (e) { e.preventDefault(); run(input.value, 'typed'); input.blur(); });
    root.querySelector('.ss-close').addEventListener('click', close);
    clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; renderIdle(); input.focus(); });
    input.addEventListener('input', function () {
      clearBtn.hidden = !input.value;
      clearTimeout(suggestTimer);
      suggestTimer = setTimeout(function () { renderSuggest(input.value); }, 80);
    });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    bodyEl.addEventListener('click', onBodyClick);
  }

  function onBodyClick(e) {
    var chip = e.target.closest('[data-ss-run]');
    if (chip) { e.preventDefault(); var t = chip.getAttribute('data-ss-run'); input.value = t; root.querySelector('.ss-clear').hidden = false; track('smart_search_click', { ss_intent: current.intent ? current.intent.key : 'none', ss_target: chip.getAttribute('data-ss-kind') || 'chip', ss_label: t }); run(t, chip.getAttribute('data-ss-kind') || 'chip'); return; }
    var a = e.target.closest('a[data-ss-target]');
    if (a) track('smart_search_click', { ss_intent: current.intent ? current.intent.key : 'none', ss_target: a.getAttribute('data-ss-target'), ss_url: a.getAttribute('href'), search_term: current.q });
  }

  function open(e) {
    if (e) e.preventDefault();
    build();
    root.hidden = false;
    document.documentElement.classList.add('ss-lock');
    if (!pushed) { try { history.pushState({ ss: 1 }, ''); pushed = true; } catch (err) {} }
    input.focus();
    if (!current.q) renderIdle();
    track('smart_search_open', { ss_source: 'mobile_nav' });
    loadData().then(function () { if (!current.q && !input.value) renderIdle(); }).catch(function () {});
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.documentElement.classList.remove('ss-lock');
    if (pushed) { pushed = false; try { history.back(); } catch (e) {} }
  }
  window.addEventListener('popstate', function () { if (root && !root.hidden) { pushed = false; root.hidden = true; document.documentElement.classList.remove('ss-lock'); } });

  function chips(list, kind) {
    return '<div class="ss-chips">' + (list || []).map(function (l) {
      return '<button type="button" class="ss-chip" data-ss-run="' + esc(l) + '" data-ss-kind="' + kind + '">' + esc(l) + '</button>';
    }).join('') + '</div>';
  }

  function renderIdle() {
    current = { q: '', intent: null };
    var pop = (DATA && DATA.popular) || ['Senior', 'Left handed', 'Bags', 'Putter', '5 iron', 'Wedges', 'Driver', "Women's sets", 'Junior', 'Outlet', 'Warranty', 'Nicklaus'];
    bodyEl.innerHTML =
      '<div class="ss-eyebrow">Popular right now</div>' + chips(pop, 'popular') +
      '<div class="ss-fit">' +
        '<div class="ss-fit__head">Not sure what you need?</div>' +
        '<p class="ss-fit__body">The Fit Finder picks your set, shaft and flex in 30 seconds.</p>' +
        '<a class="ss-btn" data-ss-target="fit_finder" href="' + esc(FIT_URL) + '">Find my set</a>' +
      '</div>';
  }

  function renderSuggest(v) {
    var typed = norm(v).trim();
    if (!typed) { renderIdle(); return; }
    if (!DATA || typed.length < 2) return;
    var out = [];
    for (var k = 0; k < DATA.intents.length && out.length < 5; k++) {
      var it = DATA.intents[k];
      var lab = norm(it.label).trim();
      var hit = lab.indexOf(typed) !== -1 || it.kw.some(function (w) { w = norm(w).trim(); return w.indexOf(typed) === 0 || typed.indexOf(w + ' ') === 0 || typed === w; });
      if (hit) out.push(it);
    }
    var html = '<div class="ss-suggest">' + out.map(function (it) {
      return '<button type="button" class="ss-suggest__row" data-ss-run="' + esc(it.label) + '" data-ss-kind="suggestion"><span>' + esc(it.label) + '</span><span class="ss-suggest__kind">' + esc(it.kind || '') + '</span></button>';
    }).join('') +
      '<button type="button" class="ss-suggest__row ss-suggest__row--all" data-ss-run="' + esc(v) + '" data-ss-kind="typed"><span>Search &ldquo;' + esc(v) + '&rdquo;</span>' + ICON_ARROW + '</button></div>';
    bodyEl.innerHTML = html;
  }

  function eyebrow(q) {
    return '<div class="ss-eyebrow ss-eyebrow--caddy"><span class="ss-dot"></span>Stix Caddy <span class="ss-eyebrow__q">&middot; &ldquo;' + esc(q) + '&rdquo;</span></div>';
  }

  function cardHtml(item, i) {
    var p = item.p, v = item.v;
    var price = v ? v.p : p.price, compare = v ? v.c : p.compare;
    var href = p.url + (v ? ('?variant=' + v.id) : '');
    var pct = p.pct_off || 0;
    var cp = CFG.currencyPrefix || '';
    return '<a class="ss-card" data-ss-target="product" data-ss-pos="' + i + '" href="' + esc(href) + '">' +
      '<span class="ss-card__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="120" height="120" loading="lazy">' : ICON_CLUB) + '</span>' +
      '<span class="ss-card__info">' +
        '<span class="ss-card__title">' + esc(p.title) + '</span>' +
        (item.pitch ? '<span class="ss-card__pitch">' + esc(item.pitch) + '</span>' : '') +
        (item.spec ? '<span class="ss-card__spec">' + esc(item.spec) + '</span>' : '') +
        '<span class="ss-card__price"><span class="ss-card__now">' + esc(cp + price) + '</span>' +
          (compare ? '<s class="ss-card__was"><span class="ss-sr">Original price: </span>' + esc(cp + compare) + '</s>' : '') +
          (pct > 0 ? '<span class="ss-card__off">' + esc(pct) + '% OFF</span>' : '') +
        '</span>' +
      '</span>' +
    '</a>';
  }

  function run(q, source) {
    q = String(q || '').trim();
    if (!q) { renderIdle(); return; }
    current = { q: q, intent: null };
    bodyEl.innerHTML = eyebrow(q) + '<div class="ss-thinking"><span class="ss-dot"></span><span class="ss-dot"></span><span class="ss-dot"></span></div>';
    track('search', { search_term: q, ss_source: source || 'typed' }, 'smart_search_query');
    loadData().then(function () {
      if (current.q !== q) return;
      var intent = findIntent(q);
      current.intent = intent;
      if (intent) return renderAnswer(intent, q);
      return renderFallback(q);
    }).catch(function () { location.href = SEARCH_URL + '?q=' + encodeURIComponent(q); });
  }

  function renderAnswer(intent, q) {
    var hs = allHandles(intent);
    var tokenHs = [];
    (intent.head + ' ' + intent.body).replace(/\{price:([a-z0-9\-]+)\}/g, function (_, h) { tokenHs.push(h); });
    return loadCards(hs.concat(tokenHs)).then(function () {
      if (current.q !== q) return;
      var lefty = isLefty(q) && intent.key !== 'left' && intent.key !== 'lh_women';
      var shown = resolveProducts(intent, q, lefty ? ['Left'] : null);
      if (lefty && !shown.length) {
        // Nothing in this category ships left-handed: answer with the lefty intent instead.
        var lt = intentByKey('left');
        if (lt) { current.intent = lt; return renderAnswer(lt, q); }
      }
      var head = fillTokens(intent.head, shown), body = fillTokens(intent.body, shown);
      // Promo strip only for real promos (price.automatic_discount metafield), not
      // standing compare-at markdowns like Outlet pricing; those show on the card only.
      var maxPct = shown.reduce(function (m, s) { return s.p.auto_discount ? Math.max(m, s.p.pct_off || 0) : m; }, 0);
      var cta = '';
      if (intent.cta) {
        var href = null;
        if (typeof intent.cta.product === 'number' && shown[intent.cta.product]) {
          var s = shown[intent.cta.product]; href = s.p.url + (s.v ? '?variant=' + s.v.id : '');
        } else if (intent.cta.url) href = url(intent.cta.url);
        if (href) cta = '<a class="ss-btn ss-btn--arrow" data-ss-target="cta" href="' + esc(href) + '">' + esc(intent.cta.label) + ICON_ARROW + '</a>';
      }
      var html = eyebrow(q) +
        '<div class="ss-answer ss-in">' +
          '<h2 class="ss-head">' + esc(head.ok ? head.text : intent.label) + '</h2>' +
          (maxPct > 0 ? '<div class="ss-promo">Save up to ' + esc(maxPct) + '% right now.</div>' : '') +
          (body.ok && body.text ? '<p class="ss-text">' + esc(body.text) + '</p>' : '') +
          ((intent.points && intent.points.length) ? '<ul class="ss-points">' + intent.points.map(function (pt) { return '<li>' + ICON_CHECK + '<span>' + esc(pt) + '</span></li>'; }).join('') + '</ul>' : '') +
          cta +
        '</div>' +
        (shown.length ? '<div class="ss-cards ss-in ss-in--2">' + shown.map(cardHtml).join('') + '</div>' : '') +
        ((intent.links && intent.links.length) ? '<div class="ss-links ss-in ss-in--3">' + intent.links.map(function (l) {
          return '<a class="ss-link" data-ss-target="link" href="' + esc(url(l.url)) + '"><span>' + esc(l.label) + '</span>' + ICON_ARROW + '</a>';
        }).join('') + '</div>' : '') +
        ((intent.also && intent.also.length) ? '<div class="ss-group ss-in ss-in--3"><div class="ss-eyebrow">People also search</div>' + chips(intent.also, 'also') + '</div>' : '') +
        '<div class="ss-more-slot"></div>' +
        '<a class="ss-all ss-in ss-in--3" data-ss-target="see_all" href="' + esc(SEARCH_URL + '?q=' + encodeURIComponent(q)) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      bodyEl.innerHTML = html;
      bodyEl.scrollTop = 0;
      track('smart_search_answer', { search_term: q, ss_intent: intent.key, ss_matched: true, ss_products: shown.length, ss_promo_pct: maxPct, ss_hand: lefty ? 'left' : 'any' });
      renderMore(intent, q, shown, isLefty(q));
    });
  }

  // "More results": Shopify's own product results under a curated answer, so shoppers
  // can keep browsing without leaving the screen. Filtered: in stock, not lightly used,
  // not already shown, left-handed when the query asks for it. Skipped for answers with
  // no products (warranty, returns...) and where native search is known to be wrong
  // ("senior" returns Junior sets). An intent can opt out with "native": false in the data.
  var NO_NATIVE = { senior: 1, lh_women: 1 };
  var MORE_MAX = 4;
  function renderMore(intent, q, shown, lefty) {
    if (intent.native === false || NO_NATIVE[intent.key] || !(intent.products && intent.products.length)) return;
    var seen = {};
    shown.forEach(function (s) { seen[s.p.handle] = 1; });
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var hs = ((((j || {}).resources || {}).results || {}).products || []).map(function (p) { return p.handle; })
          .filter(function (h) { return !seen[h]; });
        return loadCards(hs).then(function () { return hs; });
      })
      .then(function (hs) {
        if (current.q !== q || current.intent !== intent) return;
        var more = [];
        // Single-club and gear answers: full sets only match because they contain the
        // club ("putter" -> every set), so leave them out. Bags keep them (sets ship with one).
        var noSets = (intent.kind === 'CLUB' || intent.kind === 'GEAR') && intent.key !== 'bag';
        hs.forEach(function (h) {
          if (more.length >= MORE_MAX) return;
          var p = cardCache[h];
          if (!p || !p.available || /lightly used/i.test(p.title)) return;
          if (noSets && /club set/i.test(p.title)) return;
          var v = lefty ? pickVariant(p, ['Left']) : null;
          if (v === false) return;
          more.push({ p: p, v: v, spec: lefty ? 'Left-handed' : '', pitch: (DATA.pitch || {})[h] || '' });
        });
        var slot = bodyEl.querySelector('.ss-more-slot');
        if (!slot || !more.length) return;
        slot.innerHTML = '<div class="ss-group ss-more ss-in ss-in--3"><div class="ss-eyebrow">More results</div>' +
          '<div class="ss-cards">' + more.map(cardHtml).join('').replace(/data-ss-target="product"/g, 'data-ss-target="native"') + '</div></div>';
        track('smart_search_more', { search_term: q, ss_intent: intent.key, ss_native: more.length });
      })
      .catch(function () {});
  }

  function renderFallback(q) {
    var fb = (DATA && DATA.fallback) || {};
    return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var hs = ((((j || {}).resources || {}).results || {}).products || []).map(function (p) { return p.handle; });
        return loadCards(hs).then(function () { return hs; });
      })
      .catch(function () { return []; })
      .then(function (hs) {
        if (current.q !== q) return;
        var shown = hs.map(function (h) { return cardCache[h]; }).filter(function (p) { return p && p.available && !/lightly used/i.test(p.title); }).slice(0, 3)
          .map(function (p) { return { p: p, v: null, spec: '', pitch: (DATA.pitch || {})[p.handle] || '' }; });
        var html = eyebrow(q) +
          '<div class="ss-answer ss-in">' +
            '<h2 class="ss-head">' + esc(shown.length ? (fb.head || 'Here’s the closest match.') : 'We couldn’t find that one.') + '</h2>' +
            '<p class="ss-text">' + esc(fb.body || 'Tell us what you’re after in chat, or let the Fit Finder pick your set.') + '</p>' +
            '<a class="ss-btn ss-btn--arrow" data-ss-target="fit_finder" href="' + esc(FIT_URL) + '">Find my set' + ICON_ARROW + '</a>' +
          '</div>' +
          (shown.length ? '<div class="ss-cards ss-in ss-in--2">' + shown.map(cardHtml).join('') + '</div>' : '') +
          '<div class="ss-group ss-in ss-in--3"><div class="ss-eyebrow">Or try</div>' + chips((DATA && DATA.popular) || [], 'popular') + '</div>' +
          '<a class="ss-all ss-in ss-in--3" data-ss-target="see_all" href="' + esc(SEARCH_URL + '?q=' + encodeURIComponent(q)) + '">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
        bodyEl.innerHTML = html;
        track('smart_search_answer', { search_term: q, ss_intent: 'none', ss_matched: false, ss_products: shown.length });
      });
  }

  // ── 4. Wire up ─────────────────────────────────────────────────────────────
  function init() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ss-open]');
      if (b) open(e);
    });
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1500); };
    idle(function () { loadData().catch(function () {}); ensureCss(); });
    // QA convenience: ?cl_ss_open=1 opens the screen on load (preview links)
    try { if (new URLSearchParams(location.search).get('cl_ss_open') === '1') setTimeout(open, 300); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
